export default __webpack_public_path__ + "static/media/headerTitle.176dfa10.svg";